import { useState } from 'react'
import { default as DeleteIcon } from '@mui/icons-material/Delete'

export function useImageActions(emrReportData, setEmrReportData) {
  const [deletingImageIndex, setDeletingImageIndex] = useState(null)

  const handleDeleteImage = async (imageIndex, imageMediaId) => {
    try {
      setDeletingImageIndex(imageIndex)

      setEmrReportData((prev) => {
        const updatedSignedImages = prev?.uploadedSignedImages?.filter(
          (_, index) => index !== imageIndex,
        )
        const updatedImages = prev?.uploadedImages?.filter((_, index) => index !== imageIndex)
        return {
          ...prev,
          uploadedImages: updatedImages,
          uploadedSignedImages: updatedSignedImages,
        }
      })
    } catch (error) {
      console.error('Error deleting image:', error)
    } finally {
      setDeletingImageIndex(null)
    }
  }

  const createImageMenuItems = (imageIndex, imageMediaId) => {
    if (!setEmrReportData) {
      return []
    }

    return [
      {
        label: deletingImageIndex === imageIndex ? 'Deleting...' : 'Delete',
        icon: DeleteIcon,
        iconProps: {
          color: 'error',
        },
        onClick: () => handleDeleteImage(imageIndex, imageMediaId),
        disabled: deletingImageIndex === imageIndex,
      },
    ]
  }

  return {
    deletingImageIndex,
    handleDeleteImage,
    createImageMenuItems,
  }
}
